<div class="wrapper">
  <div class="circle">
    <div class="inner"></div>
  </div>
  <span class="text">{{text}}</span>
</div>